/** i18n keys for Nova mounting UI (English values in spa/app/src/i18n/template.json). */
export const NOVA_LABELS = {
  componentColour2400Tooltip: 'Black variant is not available for NOVA 2400 mm rail',
} as const

export const NOVA_RAIL_ORIENTATION = {
  shortSide: 'Parallel to short side',
  longSide: 'Parallel to long side',
} as const

export const NOVA_RAIL_ORIENTATION_OPTIONS = {
  shortSide: { label: NOVA_RAIL_ORIENTATION.shortSide, value: NOVA_RAIL_ORIENTATION.shortSide },
  longSide: { label: NOVA_RAIL_ORIENTATION.longSide, value: NOVA_RAIL_ORIENTATION.longSide },
} as const
